import { 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  updateProfile as firebaseUpdateProfile,
  updatePassword as firebaseUpdatePassword,
  type User
} from 'firebase/auth';
import { FIREBASE_AUTH } from './config';
import { handleFirebaseError } from './errors';
import type { SignUpData } from '../../types/auth';

export async function signIn(email: string, password: string) {
  try {
    const userCredential = await signInWithEmailAndPassword(FIREBASE_AUTH, email, password);
    return { user: userCredential.user, error: null };
  } catch (error) {
    return { user: null, error: handleFirebaseError(error) };
  }
}

export async function signUp({ email, password, name }: SignUpData) {
  try {
    const userCredential = await createUserWithEmailAndPassword(FIREBASE_AUTH, email, password);
    await firebaseUpdateProfile(userCredential.user, { displayName: name });
    return { user: userCredential.user, error: null };
  } catch (error) {
    return { user: null, error: handleFirebaseError(error) };
  }
}

export async function signOut() {
  try {
    await firebaseSignOut(FIREBASE_AUTH);
    return { error: null };
  } catch (error) {
    return { error: handleFirebaseError(error) };
  }
}

export function subscribeToAuthChanges(callback: (user: User | null) => void) {
  return onAuthStateChanged(FIREBASE_AUTH, callback);
}

export async function updateProfile(data: { displayName?: string; photoURL?: string }) {
  try {
    const user = FIREBASE_AUTH.currentUser;
    if (!user) throw new Error('No user logged in');
    
    await firebaseUpdateProfile(user, data);
    return { error: null };
  } catch (error) {
    return { error: handleFirebaseError(error) };
  }
}

export async function updatePassword(newPassword: string) {
  try {
    const user = FIREBASE_AUTH.currentUser;
    if (!user) throw new Error('No user logged in');
    
    await firebaseUpdatePassword(user, newPassword);
    return { error: null };
  } catch (error) {
    return { error: handleFirebaseError(error) };
  }
}